export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10569.63a6c905.jpg";